// @ts-check

/** @file Adds safe automation presentation fields to each project replica. */

import Migration from "velocious/build/src/database/migration/index.js"

/** Adds the task automation fields rendered by board and detail screens. */
export default class AddTaskAutomationPresentation extends Migration {
  /** Adds public task automation state, claim, status, and links. */
  async up() {
    await this.addColumn("tasks", "agent_state", "string", {null: true})
    await this.addColumn("tasks", "agent_claimed_by", "string", {null: true})
    await this.addColumn("tasks", "automation_runtime_status", "string", {null: true})
    await this.addColumn("tasks", "automation_runtime_links", "json", {null: true})
  }

  /** Removes only the task automation presentation columns. */
  async down() {
    await this.removeColumn("tasks", "automation_runtime_links")
    await this.removeColumn("tasks", "automation_runtime_status")
    await this.removeColumn("tasks", "agent_claimed_by")
    await this.removeColumn("tasks", "agent_state")
  }
}

AddTaskAutomationPresentation.onDatabases(["projectReplica"])
